import { Controller, useFormContext } from 'react-hook-form';
import { BoltSmallRectangleColorMintIcon, BoltSmallRectangleColorVioletIcon, BoltSmallRectangleFillIcon } from '@zep-us/zus-icons';
import { cn } from '@/utils/tailwind.util';
import { QUIZ_PLAN_FEATURES, QUOTE_PLANS, type QuotePlan } from '../constants/quizQuote.const';
import { type QuizQuoteFormValues } from '../utils/quizQuote.schema';
import { FeatureList } from './FeatureList';
const PLAN_LABEL: Record<QuotePlan, string> = {
  basic: 'Basic',
  pro: 'Pro'
};

/** 탭 아이콘 — Basic: 민트 볼트, Pro: 선택 시 바이올렛·미선택 시 회색(currentColor) 볼트. */
function PlanTabIcon({
  plan,
  selected
}: {
  plan: QuotePlan;
  selected: boolean;
}) {
  if (plan === 'basic') {
    return <BoltSmallRectangleColorMintIcon size="xs" />;
  }
  return selected ? <BoltSmallRectangleColorVioletIcon size="xs" data-sentry-element="BoltSmallRectangleColorVioletIcon" data-sentry-component="PlanTabIcon" data-sentry-source-file="PlanSelectSection.tsx" /> : <BoltSmallRectangleFillIcon size="xs" data-sentry-element="BoltSmallRectangleFillIcon" data-sentry-component="PlanTabIcon" data-sentry-source-file="PlanSelectSection.tsx" />;
}

/** "플랜 선택" — Basic/Pro 세그먼트 탭 + 선택 플랜 기능 리스트 (Figma). */
export function PlanSelectSection() {
  const {
    control
  } = useFormContext<QuizQuoteFormValues>();
  return <Controller control={control} name="plan" render={({
    field
  }) => <section className="flex w-full flex-col gap-xs">
          <h4 className="text-body-md-bold text-neutral">플랜 선택</h4>
          <div role="radiogroup" aria-label="플랜 선택" className="flex w-full gap-none rounded-sm border border-solid border-[color:var(--border-opacity-assistive,rgba(28,27,31,0.04))] bg-alternative p-3xs">
            {QUOTE_PLANS.map(plan => {
        const selected = field.value === plan;
        return <button key={plan} type="button" role="radio" aria-checked={selected} onClick={() => field.onChange(plan)} className={cn('flex flex-1 items-center justify-center gap-3xs rounded-sm px-sm py-xs text-body-lg-semibold transition-colors', selected ? 'bg-default text-default shadow-xs' : 'text-assistive')}>
                  <PlanTabIcon plan={plan} selected={selected} />
                  {PLAN_LABEL[plan]}
                </button>;
      })}
          </div>
          <FeatureList features={QUIZ_PLAN_FEATURES[field.value]} />
        </section>} data-sentry-element="Controller" data-sentry-component="PlanSelectSection" data-sentry-source-file="PlanSelectSection.tsx" />;
}